<template>
  <!-- 添加修改地址弹框 -->
  <el-dialog
    class="addPopsDialog"
    :title="onTitle"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    width="967px"
  >
    <div class="contentInfos">
      <el-form ref="formData" :model="formData" :rules="rules" label-width="120px" label-position="right">
        <el-form-item label="收件人:" prop="name">
          <el-input v-model="formData.name" placeholder="输入收件人姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码:" prop="tel">
          <el-input v-model="formData.tel" placeholder="输入收件人手机号码"></el-input>
        </el-form-item>
        <el-form-item label="所在地区:">
          <el-row>
            <el-col style="width: 254px;">
              <el-form-item label="" prop="province" class="noBottom">
                <el-select
                  v-model="formData.province"
                  placeholder="请选择您所在的省份"
                  popper-class="_addressStyle"
                  @change="seletekey($event, 'province')"
                >
                  <el-option
                    v-for="val in proviceList"
                    :key="val"
                    :label="val"
                    :value="val"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="width: 254px;margin-left:8px;">
              <el-form-item label="" prop="city" class="noBottom">
                <el-select
                  v-model="formData.city"
                  placeholder="请选择您所在的城市"
                  popper-class="_addressStyle"
                  @change="seletekey($event, 'city')"
                >
                  <el-option
                    v-for="val in cityList"
                    :key="val"
                    :label="val"
                    :value="val"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col style="width: 254px;margin-left:8px;">
              <el-form-item label="" prop="county" class="noBottom">
                <el-select
                  v-model="formData.county"
                  placeholder="请选择您所在的区/县"
                  popper-class="_addressStyle"
                  @change="seletekey($event, 'area')"
                >
                  <el-option
                    v-for="val in countyList"
                    :key="val"
                    :label="val"
                    :value="val"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="详细地址:" prop="addressDetail">
          <el-input v-model="formData.addressDetail" type="textarea" :maxlength="40" placeholder="请输入详细地址精确到门牌号如:XX小区XX单元XX栋XXXX室"></el-input>
        </el-form-item>
      </el-form>
      <el-checkbox class="setDefaultAddress" v-model="formData.isDefault">设置默认地址</el-checkbox>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="savebtn" @click="onSubmit('formData')">保存收货地址</div>
    </div>
  </el-dialog>
</template>

<script>
/*global BaseApi */
import areaList from './area.min.js'
export default {
  props: {
    isDetail: {
      require: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      onTitle: '添加地址',
      areaList,
      formData: {
        id: null,
        name: null,
        tel: null,
        area: null,
        addressDetail: null,
        postalCode: null,
        areaCode: null,
        isDefault: false,
        county: null,
        city: null,
        province: null
      },
      rules: {
        name: [
          { required: true, message: '请输入收件人姓名', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入收件人手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选中您所在的省份', trigger: 'change' }
        ],
        county: [
          { required: true, message: '请选择您所在的区/县', trigger: 'change' }
        ],
        city: [
          { required: true, message: '请选择您所在的城市', trigger: 'change' }
        ],
        addressDetail: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      proviceList: areaList.province_list, //  获取所有的省
      cityList: {},
      countyList: {},
      paramInfo: {}
    }
  },
  methods: {
    openDialog(obj) {
      this.paramInfo = obj
      if (this.paramInfo.modifyId) {
        this.onTitle = '修改地址'
      } else {
        this.onTitle = '添加地址'
      }
      this.getAddressDetails()
      this.dialogVisible = true
      // this.$refs['formData'].clearValidate()
    },
    firstCityCountry() {
      // 修改地址时第一次赋值cityList,countyList
      this.cityList = {}
      this.countyList = {}
      Object.keys(this.proviceList).filter(item => {
        if (this.proviceList[item] === this.formData.city) {
          Object.keys(this.areaList.city_list).filter(cityItem => {
            if (String(cityItem).slice(0, 2) === String(item).slice(0, 2)) {
              this.cityList[cityItem] = this.areaList.city_list[cityItem]
            }
          })
        }
      })
      Object.keys(this.areaList.county_list).filter(cityItem => {
        if (String(cityItem).slice(0, 4) === String(this.formData.areaCode).slice(0, 4)) {
          this.countyList[cityItem] = this.areaList.county_list[cityItem]
        }
      })
    },
    seletekey(e, type) {
      if (e) {
        switch (type) {
          case 'province':
            this.cityList = {}
            this.countyList = {}
            this.formData.city = null
            this.formData.county = null
            Object.keys(this.proviceList).filter(item => {
              if (this.proviceList[item] === e) {
                Object.keys(this.areaList.city_list).filter(cityItem => {
                  if (String(cityItem).slice(0, 2) === String(item).slice(0, 2)) {
                    this.cityList[cityItem] = this.areaList.city_list[cityItem]
                  }
                })
              }
            })
            break
          case 'city':
            this.countyList = {}
            this.formData.county = null
            Object.keys(this.cityList).filter(item => {
              if (this.cityList[item] === e) {
                Object.keys(this.areaList.county_list).filter(cityItem => {
                  if (String(cityItem).slice(0, 4) === String(item).slice(0, 4)) {
                    this.countyList[cityItem] = this.areaList.county_list[cityItem]
                  }
                })
              }
            })
            break
          case 'area':
            this.$forceUpdate()
            this.formData.area = this.formData.province + '/' + this.formData.city + '/' + this.formData.county + ''
            Object.keys(this.countyList).filter(item => {
              if (this.countyList[item] === e) {
                this.formData.areaCode = item
              }
            })
            break
        }
      }
    },
    getAddressDetails() {
      const that = this
      const addressDetailId = this.paramInfo.modifyId
      if (addressDetailId) {
        BaseApi.getUserAddressWithId(addressDetailId).then(response => {
          const { value, message, code } = response.data
          // eslint-disable-next-line eqeqeq
          if (code == 0) {
            if (value.length !== 0) {
              const currentaddressDetail = value[0]
              that.formData.name = currentaddressDetail.recipients
              that.formData.tel = currentaddressDetail.recipientsCellphone
              that.formData.postalCode = currentaddressDetail.postCode
              that.formData.id = currentaddressDetail.addressDetailId
              if (currentaddressDetail.region) {
                that.formData.addressDetail = JSON.parse(
                  currentaddressDetail.region
                ).address
                const region = value[0]['region']
                const jsReg = JSON.parse(region)['region']
                that.formData.area = jsReg[0]
                that.formData.areaCode = JSON.parse(
                  currentaddressDetail.region
                ).areaCode
                const areaList = that.formData.area.split('/')
                that.formData.province = areaList[0]
                that.formData.city = areaList[1]
                that.formData.county = areaList[2]
                that.firstCityCountry()
              }
              if (currentaddressDetail.defaultFlag === 1) {
                that.formData.isDefault = true
              } else {
                that.formData.isDefault = false
              }
            }
          } else {
            this.$message(message)
          }
        })
      }
    },
    handleClose() {
      this.formData = {
        id: null,
        name: null,
        tel: null,
        area: null,
        addressDetail: null,
        postalCode: null,
        areaCode: null,
        isDefault: false,
        county: null,
        city: null,
        province: null
      }
      this.$nextTick(() => {
        this.$refs['formData'].clearValidate()
        this.$refs['formData'].clearValidate('formData.city')
      })
      this.dialogVisible = false
    },
    onSubmit(formName) {
      // {"addressName":"北京市,北京市,朝阳区测试Pc地址","defaultFlag":0,"recipients":"测试传参","recipientsCellphone":"13389095763","region":"{\"region\":[\"北京市/北京市/朝阳区\"],\"address\":\"测试Pc地址\",\"areaCode\":\"110105\"}"}
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const that = this
          const addressDetailId = this.paramInfo.modifyId
          const saveType = this.paramInfo.isAdd
          const peisong = this.formData.area.replace(/(\/)/g, ',') + this.formData.addressDetail
          // '{'region':['河北省','石家庄市','长安区'],'addressDetail':'dasf'}'
          const selectedCity = this.formData.area.split(',')
          const region = { region: selectedCity, address: this.formData.addressDetail, areaCode: this.formData.areaCode }
          if (saveType === 'add') {
            const sendValue = {
              'addressName': peisong, // 收货地址
              'defaultFlag': this.formData.isDefault === true ? 1 : 0, // 是否设置为默认收获地址 (0:否 1:是)
              'postCode': this.formData.postalCode, // 邮政编码
              'recipients': this.formData.name, // 收货人
              'recipientsCellphone': this.formData.tel, //	收货人电话
              'region': JSON.stringify(region) // 地区(前端维护辅助字段)
            }
            BaseApi.saveUserAddress(sendValue).then(response => {
              const { code, message } = response.data
              // eslint-disable-next-line eqeqeq
              if (code == 0) {
                that.dialogVisible = false
                that.$refs['formData'].resetFields()
                // if (this.isDetail) {
                //   // 商品详情页新增地址弹框
                //   that.$emit('complate')
                // } else {
                that.$emit('complate')
                // }
              } else {
                this.$message(message)
              }
            })
          } else if (saveType === 'modify') {
            const sendValue = {
              'addressId': addressDetailId,
              'addressName': peisong, // 收货地址
              'defaultFlag': this.formData.isDefault === true ? 1 : 0, // 是否设置为默认收获地址 (0:否 1:是)
              'postCode': this.formData.postalCode, // 邮政编码
              'recipients': this.formData.name, // 收货人
              'recipientsCellphone': this.formData.tel, //	收货人电话
              'region': JSON.stringify(region) // 地区(前端维护辅助字段)
            }
            BaseApi.updateUserAddress(sendValue).then(response => {
              const { code, message } = response.data
              this.$message(message)
              if (code === 0 || code === '0') {
                that.dialogVisible = false
                that.$refs['formData'].resetFields()
                that.$emit('complate')
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss">
.el-select-dropdown {
  background: #ffffff !important;
  border: 0 !important;
}
.el-select-dropdown__item{
  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
  font-weight: 400;
  span{
    color: #999999;
  }
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
  color:#fff;
  span{
    color:#333333;
  }
}
.el-select-dropdown__item.selected{
  color: #333333!important;
  background-color: #eeeeee;
  text-align:left;
}
.el-select-dropdown__item.selected span{
  color: #333333;
}
// .el-popper[x-placement^=bottom] .popper__arrow::after{
//   border-bottom-color: #ffffff !important;
//   border: 0;
// }
// .el-popper[x-placement^=bottom] .popper__arrow{
//   // left:74%!important;
//   border-bottom-color: #ffffff !important;
// }
</style>
<style lang="scss" scoped>
.addPopsDialog{
    /deep/.el-dialog{
      background: #FFFFFF !important;
    }
    /deep/.el-dialog__body{
      padding: 50px 0 0;
    }
    /deep/.el-dialog__header{
      padding: 20px 0 0;
      text-align: center;
      position: relative;
      .el-dialog__title{
        font-size: 18px;
        font-family: PingFang HK-Medium, PingFang HK;
        font-weight: 500;
        color: #333333 !important;
        line-height: 21px;
      }
      .el-dialog__headerbtn {
        .el-dialog__close{
          font-size: 20px;
          color:#D9D9D9;
        }
      }
    }
    /deep/.el-dialog__footer {
      padding: 0 0 37px;
    }
    /deep/.el-form {
        .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
            content:'';
        }
        .el-form-item{
            margin-bottom: 20px;
        }
        .noBottom{
            margin-bottom: 0;
        }
        .el-form-item__label{
            font-size: 14px;
            font-family: PingFang HK-Medium, PingFang HK;
            color: #333333;
        }
        .el-input{
            width:254px;
            height: 38px;
            font-size: 14px;
            font-family: PingFang HK-Medium, PingFang HK;
            color: #999999;
            border:none;
        }
        .el-input__inner{
            width: 100%;
            height: 38px;
            line-height: 36px;
            background: #ffffff;
            border: 1px solid #D9D9D9 !important;
            color: #999999;
        }
        .el-textarea{
          width:778px;
          height: 106px;
        }
        .el-textarea__inner{
          height: 100%;
          background: #ffffff;
          border: 1px solid #D9D9D9 !important;
          padding: 10px;
          font-size: 14px;
          font-family: PingFang HK-Medium, PingFang HK;
          color: #999999;
          resize: none;
        }
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      .savebtn{
        width: 233px;
        height: 54px;
        background: linear-gradient(to right, #EA553C, #EE8C54);
        border-radius: 54px;
        border:none;
        font-size: 18px;
        font-family: PingFang HK-Medium, PingFang HK;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        line-height: 54px;
        cursor: pointer;
      }
    }
    /deep/.el-checkbox{
      margin-left: 50px;
      display: flex;
      align-items: center;
      .el-checkbox__label{
        font-size: 14px;
        font-family: PingFang HK-Medium, PingFang HK;
        font-weight: 400;
        color: #333333;
        padding-left: 4px;
      }
      .el-checkbox__inner{
        width: 12px;
        height: 12px;
        border-color: #D9D9D9;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #EE8C54;
        border-color: #EE8C54;
      }
      .el-checkbox__inner::after{
        border: 2px solid #333333;
        border-left: 0;
        border-top: 0;
        top: 0;
        left: 3px;
      }
    }
}
</style>
